import React, { Component } from 'react';
import { boolHelper } from '@quartermaster/qmlib-api';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

import { connect } from 'react-redux';
import { selectSignUpInvite } from '../../../redux/auth/selectors';

import Avatar from '../../../components/Avatar/Avatar';
import QmImage from '../../../components/Image/QmImage';
import styles from './InviteStatusStyles.scss';

class InviteStatus extends Component {
  static propTypes = {
    inviteData: PropTypes.shape({
      sender: PropTypes.shape({
        name: PropTypes.string.isRequired,
        attachment_type: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
      }),
      related_property: PropTypes.shape({
        name: PropTypes.string.isRequired,
        attachment_type: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
      }),
      community: PropTypes.shape({
        name: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
      }),
    }),
  };

  static defaultProps = {
    inviteData: null,
  };

  renderProperty() {
    const { inviteData = {} } = this.props;
    const { related_property } = inviteData;
    return (
      <>
        <Avatar size={64} user={related_property} />
        <div className={`layout--column ${styles.textContainer}`}>
          <p className={styles.subtitle}>Continue to join</p>
          <p className={styles.title}>{related_property.name}</p>
        </div>
      </>
    );
  }

  renderUser() {
    const { inviteData = {} } = this.props;
    const { sender } = inviteData;
    return (
      <>
        <Avatar size={64} user={sender} />
        <div className={`layout--column ${styles.textContainer}`}>
          <p className={styles.subtitle}>Continue to connect with</p>
          <p className={styles.title}>{sender.name}</p>
        </div>
      </>
    );
  }

  renderCommunity() {
    const { inviteData = {} } = this.props;
    const { community } = inviteData;
    return (
      <>
        <Avatar size={64} user={community} />
        <div className={`layout--column ${styles.textContainer}`}>
          <p className={styles.subtitle}>Continue to join</p>
          <p className={styles.title}>{community.name}</p>
        </div>
      </>
    );
  }

  renderStreetdeal() {
    const { inviteData = {} } = this.props;
    const { street_deal } = inviteData;
    return (
      <>
        <Avatar size={64} user={street_deal.business} />
        <div className={`layout--column ${styles.textContainer}`}>
          <p className={styles.subtitle}>Sign up to get this street deal</p>
          <p className={styles.title}>{street_deal.name}</p>
        </div>
      </>
    );
  }

  renderBusiness = () => {
    const { inviteData = {} } = this.props;
    const { sender } = inviteData;
    return (
      <>
        <Avatar size={64} user={sender} />
        <div className={`layout--column ${styles.textContainer}`}>
          <p className={styles.subtitle}>
            Sign up to connect{' '}
            {boolHelper(sender.can_bap) ? 'and book' : 'with'}
          </p>
          <p className={styles.title}>{sender.name}</p>
        </div>
      </>
    );
  };

  renderController() {
    const { inviteData } = this.props;
    if (inviteData.invitation_type === 'BUSINESS') {
      return this.renderBusiness();
    }
    if (inviteData.street_deal) return this.renderStreetdeal();
    if (inviteData.community) return this.renderCommunity();
    if (inviteData.related_property) return this.renderProperty();
    return this.renderUser();
  }

  renderBEHeader = headerConfig => (
    <div
      className={`layout--row layout-align--start-center ${styles.container}`}
      style={{
        position: 'absolute',
        backgroundColor: headerConfig.background_color,
      }}
    >
      {!!headerConfig.image && (
        <QmImage
          src={headerConfig.image}
          height={48}
          width={48}
          imgStyles={{ borderRadius: 24 }}
          className="mr-gutter"
        />
      )}
      <div className="flex-1">
        <ReactMarkdown style={{ color: headerConfig.text_color }}>
          {headerConfig.markdown_text}
        </ReactMarkdown>
      </div>
    </div>
  );

  render() {
    const { inviteData } = this.props;

    if (!!inviteData && inviteData.header) {
      return this.renderBEHeader(inviteData.header);
    }

    if (!inviteData || !inviteData.sender) return null;

    return (
      <div
        className={`layout--row layout-align--start-center ${styles.container}`}
        style={{ position: 'absolute' }}
      >
        {this.renderController()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  inviteData: selectSignUpInvite(state),
});

export default connect(mapStateToProps)(InviteStatus);
